module.exports = __webpack_public_path__ + "img/calculator-intro.33035a24.svg";